import { TimePanelDndStore } from './schema/TimePanelDndStore';
import { createStore } from 'satcheljs';
import { createDropViewState } from 'owa-dnd';

let getStore = createStore<TimePanelDndStore>('timePanelDndStore', <TimePanelDndStore>{
    dropBoxDropViewState: createDropViewState(),
    timePanelDropViewState: createDropViewState(),
    calendarTabDropViewState: createDropViewState(),
    lastDragOverHeader: null,
    shouldShowHoverDayDrop: false,
    dayViewDropTime: null,
});

export default getStore;
